var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationOutline = function SvgNotificationOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 20.167a1.833 1.833 0 0 1-1.833-1.834h3.666c0 1.013-.82 1.834-1.833 1.834m7.333-2.75H3.667v-1.834l1.833-.916V9.625c0-3.174 1.303-5.231 3.667-5.793V1.833h3.666v1.999c2.364.56 3.667 2.618 3.667 5.793v5.042l1.833.916zM11 5.27A3.3 3.3 0 0 0 8.135 6.6a5.2 5.2 0 0 0-.802 3.025v5.958h7.334V9.625a5.2 5.2 0 0 0-.803-3.025A3.3 3.3 0 0 0 11 5.27"
  })));
};
export default SvgNotificationOutline;